import LargePill from 'ext-ui/components/LargePill/LargePill'
import React from 'react'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import style from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent.style'
import { useHasSaasEntitlement } from 'src/hooks/useHasSaasEntitlement'
import { useSaasUpgradeAction } from 'src/hooks/useSaasUpgradeAction'
import { useTranslate } from 'src/localization/Trns'
import { getSaasTierLabel } from 'src/models/organizations.models'
import { UserFeature } from 'src/models/user.models'
import { useQueryOwnUser } from 'src/queries/users.queries'
interface SaasUpgradeOrContentProps extends React.PropsWithChildren {
  illustration: React.ReactElement
  title: string
  description: string
  disclaimer?: React.ReactNode
  /**
   * translation source string to use for extra copy on the CTA large pill, will not render if undefined
   * Note: assumes that it may need a `${tier}` variable for the tier label, which it gets from the required tier for the feature
   */
  ctaDetailSrc?: string
  onCtaClick?: () => void
  feature: UserFeature
}

const SaasUpgradeOrContent: React.FC<SaasUpgradeOrContentProps> = (props) => {
  const {
    illustration,
    title,
    description,
    disclaimer,
    ctaDetailSrc,
    onCtaClick,
    feature,
    children,
  } = props

  const { data: user } = useQueryOwnUser({})
  const translate = useTranslate()

  const { upgradeRequired, loading, requiredTier } = useHasSaasEntitlement({
    feature,
  })

  const upgradeAction = useSaasUpgradeAction(user?.organizationId)

  if (loading) {
    return <LoadingBackgroundPage />
  }

  if (upgradeRequired && requiredTier) {
    return (
      <div css={style} className={'SaasPromoOrContent'}>
        <div>{illustration}</div>
        <div className="flex-column align-center justify-center gap-3">
          <span className="title">{title}</span>
          <span className="description">{description}</span>
          {disclaimer && <span className="disclaimer">{disclaimer}</span>}
        </div>
        <LargePill
          title={translate('Upgrade to Extend ${tier}', {
            tier: getSaasTierLabel(requiredTier),
          })}
          subtitle={
            ctaDetailSrc &&
            translate(ctaDetailSrc, { tier: getSaasTierLabel(requiredTier) })
          }
          onClick={() => {
            onCtaClick?.()
            if (requiredTier) {
              upgradeAction(
                requiredTier,
                `Saas Upgrade Feature Gate - ${title}`,
              )
            }
          }}
        />
      </div>
    )
  } else {
    return children
  }
}

export default SaasUpgradeOrContent
